import { inventoryDashboardApi } from "../../api";

const InventoryDashboardService = {
  /**
   * 📦 Obtiene las estadísticas del dashboard de inventario.
   * GET /api/dashboard/inventory/stats
   */
  getStats: async () => {
    try {
      const response = await inventoryDashboardApi.fetchCustom("/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default InventoryDashboardService;
